import SearchServices from "../../services/SearchServices";

export const GET_SEARCH_REQUEST = "GET_SEARCH_REQUEST";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";
export const GET_SEARCH_ERROR = "GET_SEARCH_ERROR";

export const GET_TAGS_REQUEST = "GET_TAGS_REQUEST";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";

export const SET_REFINEMENTS = "SET_REFINEMENTS";

export const CLEAR_REFINEMENTS = "CLEAR_REFINEMENTS";

export const getEvents = (
  query,
  locale,
  country,
  region,
  dateRefinementObj,
  onlineOnly
) => {
  return dispatch => {
    dispatch({ type: GET_SEARCH_REQUEST });
    SearchServices.getEvents(
      query,
      locale,
      country,
      region,
      dateRefinementObj,
      onlineOnly
    )
      .then(res => {
        dispatch({
          type: GET_SEARCH_SUCCESS,
          locationEvents: res
        });
      })
      .catch(err => {
        dispatch({ type: GET_SEARCH_ERROR, error: err });
      });
  };
};

export const setRefinements = updatedRefinements => {
  return dispatch => {
    dispatch({ type: SET_REFINEMENTS, updatedRefinements: updatedRefinements });
  };
};

export const clearRefinements = () => {
  return dispatch => {
    dispatch({ type: CLEAR_REFINEMENTS });
  };
};

export const getTags = (userId, locale) => {
  return dispatch => {
    dispatch({ type: GET_TAGS_REQUEST });
    SearchServices.getTags(userId, locale)
      .then(tags => {
        dispatch({
          type: GET_TAGS_SUCCESS,
          tags: tags
        });
      })
      .catch(err => {
        dispatch({ type: GET_TAGS_ERROR, error: err });
      });
  };
};
